<template>

	<span :style="icoStyle" :class="'ico-'+ico">
		<svg viewBox="0 0 24 24" v-if="ico=='undo'">
			<path fill="currentColor" d="M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z" />
		</svg>
		<svg viewBox="0 0 24 24" v-if="ico=='redo'">
			<path fill="currentColor" d="M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z" />
		</svg>
		<svg viewBox="0 0 24 24" v-if="ico=='search'">
	    <path fill="currentColor" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
		</svg>

		<svg viewBox="0 0 24 24" v-if="ico=='loading'">
			<path fill="currentColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
		</svg>


		<svg v-if="ico=='gridview'" viewBox="0 0 24 24"><path fill="currentColor" d="M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3" /></svg>

		<svg v-if="ico=='listview'" viewBox="0 0 24 24"><path fill="currentColor" d="M3 5H21V9H3V5M3 10H21V14H3V10M3 15H21V19H3V15Z" /></svg>

    <svg v-if="ico=='target'"viewBox="0 0 24 24">
      <path fill="currentColor" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
    </svg>

    <svg v-if="ico=='logo'" viewBox="0 0 342 572">
  		<path fill="currentColor" d="M1649 5687 c-24 -13 -141 -78 -259 -144 -118 -66 -276 -153 -350 -193 -74 -40 -178 -104 -230 -143 -169 -125 -341 -317 -454 -504 -110 -183 -218 -463 -273 -703 l-28 -125 1 -375 c1 -206 7 -446 14 -533 l13 -157 -32 -59 c-38 -73 -50 -141 -29 -173 9 -13 44 -60 80 -104 91 -114 102 -158 102 -379 0 -191 -13 -273 -71 -440 -19 -55 -37 -110 -40 -122 -3 -12 11 -72 32 -134 125 -381 398 -778 760 -1107 122 -111 363 -295 378 -289 14 5 13 51 -7 367 -35 525 -40 687 -41 1175 0 281 2 564 5 629 l5 119 -420 261 -420 261 0 259 c0 170 4 261 10 263 6 2 38 -15 72 -37 255 -165 718 -390 958 -466 87 -27 87 -304 0 -722 -19 -91 -37 -173 -40 -182 -4 -12 43 -65 157 -179 89 -88 164 -161 168 -161 4 0 79 73 168 161 114 114 161 167 157 179 -16 50 -77 364 -90 464 -20 157 -19 316 3 381 14 40 23 52 47 59 240 76 703 301 958 466 34 22 66 39 72 37 6 -2 10 -93 10 -263 l0 -259 -420 -261 -420 -261 5 -119 c3 -65 5 -348 5 -629 -1 -488 -6 -650 -41 -1175 -20 -316 -21 -362 -7 -367 15 -6 256 178 378 289 362 329 635 726 760 1107 21 62 35 122 32 134 -3 12 -21 67 -40 122 -58 167 -71 249 -71 440 0 221 11 265 102 379 36 44 71 91 80 104 21 32 9 100 -29 173 l-32 59 13 157 c7 87 13 327 14 533 l1 375 -28 125 c-55 240 -163 520 -273 703 -113 187 -285 379 -454 504 -52 39 -156 103 -230 143 -74 40 -232 127 -350 193 -271 152 -300 167 -320 167 -9 0 -36 -10 -61 -23z" transform="matrix(.1 0 0 -.1 0 572)"/>
		</svg>



	</span>
</template>

<script>
export default {
	props:['ico','size'],
	computed:{
		icoStyle(){
			return {
				display:'block',
				width:(this.size || 20 )+'px',
				height:(this.size || 20 )+'px',
			}
		}
	}
}
</script>

<style scoped>
	svg { display:block; height:100%; width:100%; }
	.ico-loading svg{ animation: rotating 0.5s linear infinite;}

</style>
